module.exports = __webpack_public_path__ + "static/media/new_ic_bell.25ba17ed.svg";